import IHocContext from '@@types/IHocContext';

import hoc from '~/components/hoc';
import { map, values } from 'ramda';
import * as React from 'react';

import Notification from '../Notification/Notification';
import styles from './notificationWrapper.module.scss';

const NotificationWrapper: React.FC<IHocContext> = ({ data }) => {
  const { notifications } = data.notificationStore;
  const notificationList = values(notifications);

  const renderNotification = (notification) => {
    return (
      <Notification
        key={notification.id}
        notification={notification}
        close={data.notificationStore.closeNotification}
      />
    );
  };

  return <div className={styles.wrapper}>{map(renderNotification, notificationList)}</div>;
};

export default hoc(NotificationWrapper);
